// extracted by mini-css-extract-plugin
export var container = "_qy-0";
export var dotAnimation = "_qy-2";
export var dotsLoading = "_qy-1";